import React, { useState } from "react";
import { IconButton, InputAdornment } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FieldHeader, TextInput } from "../../../../components/General";
import {
  LoginContainer,
  LoginButton,
  LoginGradient,
  LoginHeader,
  LoginLogo,
  LoginNav,
  LoginSubHeader,
  InnerNavContainer,
  PlainButton,
} from "../../components";
import useCreateUser from "../../../../hooks/mutations/admin/useCreateUser";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import login from "../../../../assets/logos/login.svg";
import {
  adminOnboardingFullPath,
  adminLoginFullPath,
} from "../../../../routes/paths";

const SignUp = () => {
  const navigate = useNavigate();

  // state
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [showPassword, setShowPassword] = useState<boolean | null>(null);
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");

  // Mutations
  const { mutate: createUser } = useCreateUser({
    onSuccessHandler: () => navigate(adminOnboardingFullPath),
  });

  const handleSignUp = async () => {
    if (!email || !password) {
      toast.error("Please fill out all fields");
      return;
    }

    createUser({ email, password, firstName, lastName });
  };

  return (
    <LoginContainer>
      <LoginNav>
        <InnerNavContainer>
          <LoginHeader>Get started</LoginHeader>
          <LoginSubHeader>
            Easily launch a custom emergency savings benefit for your employees
            in a few simple steps.
          </LoginSubHeader>
          <FieldHeader sx={{ margin: "40px 0 0" }}>Work Email</FieldHeader>
          <TextInput
            id="email-field"
            size="small"
            placeholder="Work email"
            value={email}
            focused
            onChange={(event) => setEmail(event.target.value)}
          />
          <FieldHeader>Password</FieldHeader>
          <TextInput
            id="password-field"
            placeholder="Password"
            size="small"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    size={"small"}
                    edge="end"
                  >
                    {showPassword ? (
                      <VisibilityOff fontSize="small" />
                    ) : (
                      <Visibility fontSize="small" />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <FieldHeader>First Name</FieldHeader>
          <TextInput
            id="first-name-field"
            size="small"
            value={firstName}
            placeholder="First name"
            onChange={(event) => setFirstName(event.target.value)}
          />
          <FieldHeader>Last Name</FieldHeader>
          <TextInput
            id="last-name-field"
            size="small"
            value={lastName}
            placeholder="Last name"
            onChange={(event) => setLastName(event.target.value)}
          />
          <LoginButton
            children={"Create company account"}
            onClick={handleSignUp}
          />
          <PlainButton
            children={"Have an account? Login here."}
            onClick={() => navigate(adminLoginFullPath)}
            sx={{ marginTop: "16px" }}
          />
        </InnerNavContainer>
      </LoginNav>
      <LoginGradient>
        <LoginLogo src={login} alt="logo" />
      </LoginGradient>
    </LoginContainer>
  );
};

export default SignUp;
